import renderApp from './curbside/index';

// * This checks if the store is open

window.addEventListener('store-status', (e) => {
  const isOpen = e.detail.isStoreOpen;
  localStorage.setItem('store-status', isOpen);
});

window.curbside = {
  // checkIfOpen: checkIfOpen,
  renderApp: renderApp,
};
